import * as effects from 'redux-saga/effects';

import { chatActions } from '../../actions';
import { api } from '../../../../server/api';

export function* fetchMessages({
  payload,
}) {
  try {
    yield effects.put(chatActions.startFetching());
    const response = yield effects.apply(api, api.get, [
      { endpoint: `chats/${payload}/messages/` },
    ]);
    if (!response.ok) {
      throw new Error('error');
    }
    const data = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(chatActions.fillMessages(data));
  } catch (e) {
    console.error(e);
  } finally {
    yield effects.put(chatActions.stopFetching());
  }
}
